import productHeadset from "../assets/website-dev/product-headset.svg";
import productWatch from "../assets/website-dev/product-watch.svg";
import productChair from "../assets/website-dev/product-chair.svg";
import productHub from "../assets/website-dev/product-hub.svg";
import productLamp from "../assets/website-dev/product-lamp.svg";
import productKeyboard from "../assets/website-dev/product-keyboard.svg";
import productSpeaker from "../assets/website-dev/product-speaker.svg";
import productStand from "../assets/website-dev/product-stand.svg";
import productMouse from "../assets/website-dev/product-mouse.svg";
import productWebcam from "../assets/website-dev/product-webcam.svg";
import productPowerbank from "../assets/website-dev/product-powerbank.svg";

export const wdWordPressPlugins = [
    { name: "SEO Toolkit", desc: "Rank-ready metadata and sitemaps" },
    { name: "Custom Theme", desc: "Brand-aligned layouts and blocks" },
    { name: "Blog Engine", desc: "Editorial workflows and scheduling" },
    { name: "Security Shield", desc: "Hardening, backups, and monitoring" },
];

export const wdEcommerceProducts = [
    {
        name: "Wireless Headset",
        price: "₹2,499",
        stock: "In Stock",
        image: productHeadset,
        imageAlt: "Wireless headset product",
    },
    {
        name: "Smart Watch",
        price: "₹4,999",
        stock: "Low Stock",
        image: productWatch,
        imageAlt: "Smart watch product",
    },
    {
        name: "Office Chair",
        price: "₹8,750",
        stock: "In Stock",
        image: productChair,
        imageAlt: "Ergonomic office chair product",
    },
    {
        name: "USB-C Hub",
        price: "₹1,299",
        stock: "In Stock",
        image: productHub,
        imageAlt: "USB-C hub product",
    },
    {
        name: "Desk Lamp",
        price: "₹1,899",
        stock: "In Stock",
        image: productLamp,
        imageAlt: "Desk lamp product",
    },
    {
        name: "Wireless Keyboard",
        price: "₹1,599",
        stock: "In Stock",
        image: productKeyboard,
        imageAlt: "Wireless keyboard product",
    },
    {
        name: "Bluetooth Speaker",
        price: "₹3,299",
        stock: "In Stock",
        image: productSpeaker,
        imageAlt: "Bluetooth speaker product",
    },
    {
        name: "Laptop Stand",
        price: "₹2,199",
        stock: "In Stock",
        image: productStand,
        imageAlt: "Laptop stand product",
    },
    {
        name: "Gaming Mouse",
        price: "₹1,799",
        stock: "Low Stock",
        image: productMouse,
        imageAlt: "Gaming mouse product",
    },
    {
        name: "Webcam",
        price: "₹2,899",
        stock: "In Stock",
        image: productWebcam,
        imageAlt: "Webcam product",
    },
    {
        name: "Power Bank",
        price: "₹1,499",
        stock: "In Stock",
        image: productPowerbank,
        imageAlt: "Power bank product",
    },
];
